"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SNACKBAR_ERROR = exports.SNACKBAR_INFO = exports.SNACKBAR_WARNING = exports.SNACKBAR_SUCCESS = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const js_1 = require("@mdi/js");
const react_2 = __importDefault(require("@mdi/react"));
exports.SNACKBAR_SUCCESS = "success";
exports.SNACKBAR_WARNING = "warning";
exports.SNACKBAR_INFO = "information";
exports.SNACKBAR_ERROR = "error";
function Snackbar({ type, msg, close, noTrans }) {
    return (react_1.default.createElement("div", { className: `${type} is-notification is-absolute has-background-white has-width-350 p-3 has-border-radius-small` },
        react_1.default.createElement("span", { className: "notification-title has-text-weight-semibold is-flex is-align-items-center" },
            type === exports.SNACKBAR_SUCCESS && (react_1.default.createElement(react_2.default, { path: js_1.mdiCheckCircle, size: 1, color: "#1ad598" })),
            type === exports.SNACKBAR_INFO && (react_1.default.createElement(react_2.default, { path: js_1.mdiAlertCircle, size: 1, color: "#1d98f2" })),
            type === exports.SNACKBAR_WARNING && (react_1.default.createElement(react_2.default, { path: js_1.mdiAlert, size: 1, color: "#f9b959" })),
            type === exports.SNACKBAR_ERROR && (react_1.default.createElement(react_2.default, { path: js_1.mdiAlertCircle, size: 1, color: "#ea3a3d" })),
            react_1.default.createElement("p", { className: "ml-2 notification-title-text" }, noTrans ? type : react_1.default.createElement(react_i18next_1.Trans, { i18nKey: type })),
            react_1.default.createElement("div", { className: "ml-auto is-clickable is-flex", onClick: () => close() },
                react_1.default.createElement(react_2.default, { path: js_1.mdiClose, size: 1, color: "#374355" }))),
        react_1.default.createElement("p", { className: "mt-4" }, noTrans ? msg : react_1.default.createElement(react_i18next_1.Trans, { i18nKey: msg }))));
}
exports.default = Snackbar;
//# sourceMappingURL=Snackbar.js.map